import { Text } from '../../../components/shared/text';
import { formatNumberEuro } from '../../../project/helpers';
import { type WarrantyRequest } from '../../../store/warrantyRequest/warrantyRequestModels';

const WarrantyBasket: React.FC<{
  request: WarrantyRequest;
}> = ({ request }) => {
  let total = 0,
    totalEcoPart = 0,
    totalEcoContr = 0;

  return request?.articles?.length ? (
    <>
        <div
          //data-min-length="700"
          className="list_view_container cart"
          data-view="grid"
          //data-border=""
          data-radius="5"
        >
          <group className="list_view_scroller">
            <div className="list_view">
              <div className="title">
                <group data-align="center" data-wrap="no">
                  <group data-length="autofit" data-space="10">
                    <Text className="">garantie.demande.etapes.3.panier.article</Text>
                  </group>
                  <group data-length="80" data-space="10">
                    <Text data-position="center" className="">
                      garantie.demande.etapes.2.SelectArticles.qte
                    </Text>
                  </group>
                  {request.typedemande === 'commande' && (
                    <>
                      <group data-length="100" data-space="10">
                        <Text data-position="right" className="">
                          garantie.demande.etapes.3.panier.prixhtu
                        </Text>
                      </group>
                      <group data-length="80" data-space="10">
                        <Text data-position="right" className="">
                          garantie.demande.etapes.3.panier.ecopart
                        </Text>
                      </group>
                      <group data-length="80" data-space="10">
                        <Text data-position="right" className="">
                          garantie.demande.etapes.3.panier.eco_contr
                        </Text>
                      </group>
                      <group data-length="80" data-space="10"  data-sticky="right">
                        <Text data-position="right" className="">
                          garantie.demande.etapes.3.panier.total
                        </Text>
                      </group>
                    </>
                  )}
                </group>
              </div>



              
              {request?.articles?.map((article) => {
                let eco_contr = Math.max(
                  (article.articleReseau?.poids ?? 0) * (article.articleReseau?.pu_pmcb ?? 0) * article.pivot.quantite,
                  0.01
                );

                let _total =
                    parseFloat(article?.articleReseau?.prix_ht_remise?.toString?.() ?? '0') * article.pivot.quantite +
                    (article?.articleReseau?.deee ?? 0) +
                    eco_contr,
                  isAvg = request?.garantie_type?.isAvg && request.satc_attente !== 'refusee';

                total += isAvg ? 0 : _total;
                totalEcoPart += isAvg ? 0 : article?.articleReseau?.deee;
                totalEcoContr += isAvg ? 0 : eco_contr;

                const qte = article.pivot.quantite;

                return (
                  <div className="item" key={article.uuid}>
                    <group  data-align="center" data-space="10" data-gap="5" data-wrap="no">
                      <group data-space="10" data-gap="5" data-wrap="no" data-length="autofit">
                        <text data-weight="800">[{article.reference}]</text>
                        <text data-weight="800" data-wrap="wrap">
                          {article.libelle}
                        </text>
                      </group>
                      <group data-space="10" data-length="80" data-align="center" >
                        <text data-wrap="wrap" data-position="center">
                          {qte}
                        </text>
                      </group>

                      {request.typedemande === 'commande' && (
                        <>
                          <group data-space="10" data-length="100" data-position="left">
                            <Text data-position="right" className="">
                              {formatNumberEuro(isAvg ? 0 : article.articleReseau?.prix_ht_remise ?? 0, article.articleReseau?.reseau?.currency)}
                            </Text>
                          </group>
                          <group data-space="10" data-length="80">
                            <Text data-position="right" className="">
                              {formatNumberEuro(isAvg ? 0 : article.articleReseau?.deee ?? 0, article.articleReseau?.reseau?.currency)}
                            </Text>
                          </group>
                          <group data-space="10" data-length="80">
                            <Text data-position="right" className="">
                              {formatNumberEuro(isAvg ? 0 : eco_contr ?? 0, article.articleReseau?.reseau?.currency)}
                            </Text>
                          </group>
                          <group data-space="10" data-length="80" data-sticky="right">
                            <Text data-position="right" className="">
                              {formatNumberEuro(isAvg ? 0 : _total, article.articleReseau?.reseau?.currency)}
                            </Text>
                          </group>
                        </>
                      )}
                    </group>
                  </div>
                );
              })}

              <group>
                {request.typedemande === 'commande' && (
                  <group data-direction="column" data-wrap="no" data-space-vertical="20" data-gap="5">
                    <group data-wrap="no">
                      <group data-length="autofit" data-hide=""></group>

                      <group data-gap="10" data-wrap="no" data-width="auto" data-sticky="right">
                        <Text data-length="130" data-text-align="right" data-space-horizontal="10">
                          garantie.demande.etapes.3.panier.total
                        </Text>
                        <text data-length="80" data-text-align="right" data-space-horizontal="10">
                          {formatNumberEuro(total, request.reseau_commercial?.currency)}
                        </text>
                      </group>
                    </group>

                    <group data-wrap="no">
                      <group data-length="autofit" data-hide=""></group>

                      <group data-gap="10" data-wrap="no" data-width="auto" data-sticky="right">
                        <Text data-length="130" data-text-align="right" data-space-horizontal="10">
                          garantie.demande.etapes.3.panier.totalEcopart
                        </Text>
                        <text data-length="80" data-text-align="right" data-space-horizontal="10">
                          {formatNumberEuro(totalEcoPart, request.reseau_commercial?.currency)}
                        </text>
                      </group>
                    </group>
                    <group data-wrap="no">
                      <group data-length="autofit" data-hide=""></group>

                      <group data-gap="10" data-wrap="no" data-width="auto" data-sticky="right">
                        <Text data-length="130" data-text-align="right" data-space-horizontal="10">
                          garantie.demande.etapes.3.panier.totalEcocontr
                        </Text>
                        <text data-length="80" data-text-align="right" data-space-horizontal="10">
                          {formatNumberEuro(totalEcoContr, request.reseau_commercial?.currency)}
                        </text>
                      </group>
                    </group>
                    <group data-wrap="no">
                      <group data-length="autofit" data-hide=""></group>

                      <group data-gap="10" data-wrap="no" data-width="auto" data-sticky="right">
                        <Text data-length="130" data-text-align="right" data-space-horizontal="10">
                          garantie.demande.etapes.3.panier.tva
                        </Text>
                        <text data-length="80" data-text-align="right" data-space-horizontal="10">
                          {formatNumberEuro(total * 0.2, request.reseau_commercial?.currency)}
                        </text>
                      </group>
                    </group>

                    <group data-wrap="no">
                      <group data-length="autofit" data-hide=""></group>

                      <group data-gap="10" data-wrap="no" data-width="auto" data-sticky="right">
                        <Text data-length="130" data-text-align="right" data-space-horizontal="10">
                          garantie.demande.etapes.3.panier.totalttc
                        </Text>
                        <text data-length="80" data-text-align="right" data-space-horizontal="10">
                          {formatNumberEuro(total * 1.2, request.reseau_commercial?.currency)}
                        </text>
                      </group>
                    </group>
                  </group>
                )}
              </group>
            </div>
          </group>
        </div>      
      {request?.articles?.map((article) => {
        let _total = parseFloat(article?.articleReseau?.prix_ht_remise?.toString?.() ?? '') * article.pivot.quantite,
          isAvg = request?.garantie_type?.isAvg && request.satc_attente !== 'refusee';

        total += isAvg ? 0 : _total;
        const qte = article.pivot.quantite;
        if (qte) {}
        return <></>
      })}
    </>
  ) : (
    <></>
  );
};

export default WarrantyBasket;
